module.exports = __webpack_public_path__ + "static/media/state-of-charge.8d5d523a.svg";